<template>

    <div class="grid gap-y-4">
        <h2>My Account is your fastest way to reorder previous jobs with no modifications or changes. It’s secure and
            easy!
            Search all of your reorder-ready jobs and choose which jobs you want to reorder. </h2>

        <!-- button to goto https://orders.protocase.com/myaccount on click -->
        <a href="https://orders.protocase.com/myaccount" target="_blank" class="bg-green-600 w-1/2 text-white p-2 rounded-md">My Account</a>

    </div>


</template>

<script setup>

import Button from '../formComponents/Button.vue';
import { inject } from 'vue';

const form = inject('form')
</script>
